import BaseService from 'services/BaseService';

export class UserProfileFieldDefinitionService extends BaseService {
	_type = 'field_definition';
	_typeKey = 'type';
}
